import {
  IconHeart,
  IconScale,
  IconTrendingUp,
  IconGift,
  IconHome,
  IconBook,
  IconCrown,
  IconCoins,
  IconBulb,
  IconUsers,
  IconStar,
} from "@tabler/icons-react";
import Card from "./Card";
import styles from "../TalentProfile.module.css";
import { PRIORITY_ICON_KEY } from "../../../../utils/functions";

// Maps the key stored in PRIORITY_ICON_KEY -> the actual icon component
const ICON_MAP = {
  scale: IconScale,
  trendingUp: IconTrendingUp,
  gift: IconGift,
  home: IconHome,
  book: IconBook,
  crown: IconCrown,
  coins: IconCoins,
  bulb: IconBulb,
  users: IconUsers,
};

export default function WorkPrioritiesCard({ priorities }) {
  return (
    <Card
      icon={IconHeart}
      title="Work Priorities"
      subtitle="What matters most to this talent"
    >
      <div className={styles.priorityList}>
        {priorities?.map((p) => {
          const Icon = ICON_MAP[PRIORITY_ICON_KEY[p]] || IconStar;
          return (
            <span key={p} className={styles.priorityChip}>
              <Icon size={16} /> {p}
            </span>
          );
        })}
      </div>
    </Card>
  );
}
